import Box from '@mui/material/Box';

import { Typography } from '../Typography/Typography';

interface Props {
  colour: number[] | string;
  outlineColour?: string;
  dataTestId?: string;
  size?: number;
  label?: string;
}

export const ColourIndicator = ({
  colour,
  outlineColour,
  dataTestId = 'colour-indicator',
  size = 20,
  label,
}: Props) => {
  const indicatedColour = typeof colour === 'string' ? colour : `rgb(${colour[0]}, ${colour[1]}, ${colour[2]})`;
  const borderColour = outlineColour ?? indicatedColour;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Box
        data-testid={dataTestId}
        sx={{
          width: `${size}px`,
          height: `${size}px`,
          bgcolor: indicatedColour,
          borderRadius: 1,
          border: 1,
          borderColor: borderColour,
          mr: 1,
        }}
      />
      {label ? (
        <Typography
          variant="caption"
          noWrap={true}
          fontWeight="medium"
          sx={{
            mr: 2,
            userSelect: 'none',
          }}
        >
          {label}
        </Typography>
      ) : null}
    </Box>
  );
};
